import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import ROUTES from "./common-definitions/routes";
import LiveStreamViewPage from "./components/pages/LiveStreamViewPage";
import NotFoundPage from "./components/pages/NotFoundPage";
import { UserReducer, UserContext, InitialUserState } from "./context/user";
import {
  ProgramReducer,
  ProgramContext,
  InitialProgramState,
} from "./context/program";
import { useReducerWithGraphEnhancedDispatch } from "./hooks/\bgraphEnhancedDispatch";

const NoAuthedApp = () => {
  const [UserState, UserDispatch] = useReducerWithGraphEnhancedDispatch({
    reducer: UserReducer,
    initialState: InitialUserState,
  });
  const [ProgramState, ProgramDispatch] = useReducerWithGraphEnhancedDispatch({
    reducer: ProgramReducer,
    initialState: InitialProgramState,
  });
  return (
    <UserContext.Provider value={{ UserState, UserDispatch }}>
      <ProgramContext.Provider value={{ ProgramState, ProgramDispatch }}>
        <Router>
          <Switch>
            <Route path={ROUTES.LIVESTREAM_VIEW_PAGE} exact>
              <LiveStreamViewPage />
            </Route>
            <Route path={ROUTES.ERROR_404} exact>
              <NotFoundPage />
            </Route>
            <Route>
              <Redirect to={ROUTES.ERROR_404} />
            </Route>
          </Switch>
        </Router>
      </ProgramContext.Provider>
    </UserContext.Provider>
  );
};

export default NoAuthedApp;
